import React from 'react';
import type { SentItem } from '../../../../types/admin';
import { TYPE_CONFIG, TARGET_CONFIG } from './communicationsConfig';

interface Props {
  items: SentItem[];
}

const formatTime = (iso: string) =>
  new Date(iso).toLocaleString('it-IT', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });

const SentHistory: React.FC<Props> = ({ items }) => {
  if (items.length === 0) return null;

  return (
    <section className="ac-section">
      <h2 className="ac-section-title">
        <i className="bi bi-clock-history me-2" />
        Invii di questa sessione
      </h2>
      <div className="ac-history-list">
        {[...items].reverse().map((item) => {
          const tc = TYPE_CONFIG[item.payload.type];
          const tg = TARGET_CONFIG[item.payload.target];
          return (
            <div key={item.id} className="ac-history-item">
              <div className={`ac-history-type ${tc.className}`}>
                <i className={`bi ${tc.icon}`} />
              </div>
              <div className="ac-history-body">
                <p className="ac-history-title">{item.payload.title}</p>
                <p className="ac-history-meta">
                  <i className={`bi ${tg.icon} me-1`} />
                  {tg.label}
                  <span className="ac-history-time">
                    {formatTime(item.sentAt)}
                  </span>
                </p>
              </div>
              <span className="ac-history-sent">
                <i className="bi bi-check2 me-1" />
                Inviato
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default SentHistory;
